"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.formatTime = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTime = function formatTime(time, format, visibleDuration) {
  var lessThan3DaysShown = visibleDuration < 1000 * 60 * 60 * 24 * 3;
  if (format === "none") return visibleDuration > 10 ? Math.round(time).toString() : time.toFixed(2 - Math.log(visibleDuration) / Math.log(10));

  if (format === "dates") {
    return (0, _moment.default)(time).format("L") + (!lessThan3DaysShown ? "" : "\n" + (0, _moment.default)(time).format("h:mm:ss a"));
  }

  var showNs = visibleDuration < 5;
  var showMs = visibleDuration < 5000;
  var ns = Math.floor(time * 1000 % 1000);
  var ms = Math.floor(time % 1000);
  var secs = Math.floor(time / 1000 % 60);
  var mins = Math.floor(time / 60000 % 60);
  var hours = Math.floor(time / (60000 * 60));
  if (time < 0) return "< 00:00:00";
  return [hours, mins, secs].map(function (t) {
    return t.toString().padStart(2, "0");
  }).join(":") + (showMs ? ".".concat(ms.toString().padStart(3, "0")) : "") + (showNs ? "\n+".concat(ns.toString(), " ns") : "");
};

exports.formatTime = formatTime;
var _default = formatTime;
exports.default = _default;